export default __webpack_public_path__ + "static/media/b6.4bce1043.svg";